import React, { Component } from 'react'
import Tooltip from 'form/components/molecules/mTooltip'

import {
  Text,
  TextAppearance,
  Richtext,
  TextTag,
  createTagOverride
} from '@volkswagen-onehub/components-core'

class TextWithTooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTooltip: false
    }
  }

  render() {
    const {
      textTag,
      textAppearance,
      hasTooltip,
      text,
      tooltipText
    } = this.props

    return (
      <>
        {hasTooltip && (
          <Tooltip
            text={text}
            textTag={textTag}
            textAppearance={TextAppearance[textAppearance]}
            tooltipText={tooltipText}
          />
        )}
        {!hasTooltip && (
          <Richtext
            markdown={text}
            overrides={{
              p: createTagOverride(Text, {
                tag: TextTag.div,
                appearance: TextAppearance[textAppearance]
              }),
              h1: createTagOverride(Text, {
                tag: TextTag.h1,
                appearance: TextAppearance[textAppearance]
              }),
              h2: createTagOverride(Text, {
                tag: TextTag.h2,
                appearance: TextAppearance[textAppearance]
              }),
              h3: createTagOverride(Text, {
                tag: TextTag.h3,
                appearance: TextAppearance[textAppearance]
              }),
              h4: createTagOverride(Text, {
                tag: TextTag.h4,
                appearance: TextAppearance[textAppearance]
              }),
              h5: createTagOverride(Text, {
                tag: TextTag.h5,
                appearance: TextAppearance[textAppearance]
              }),
              h6: createTagOverride(Text, {
                tag: TextTag.h6,
                appearance: TextAppearance[textAppearance]
              })
            }}
          />
        )}
      </>
    )
  }
}

export default TextWithTooltip
